<template>
	<div class="component-show">
		<div class="common-btn-area">
			<span class="btn" @click="$router.go(-1)"><i class="fas fa-undo"></i> 戻る</span>
		</div>
		<FunctionTitle :title="mainTitle" />
		<CommonFlame :title="title">
			<div class="card-list">
				<table class="user-list-table">
					<tr>
						<th class="user-list-table__title">部品名</th>
						<td>{{ component.name }}</td>
					</tr>

					<tr>
						<th class="user-list-table__title">品番</th>
						<td>{{ component.part_number }}</td>
					</tr>

					<tr>
						<th class="user-list-table__title">説明文</th>
						<td>{{ component.description }}</td>
					</tr>

					<tr>
						<th class="user-list-table__title">特定の製品への所属</th>
						<td>{{ isBelongsToProduct }}</td>
					</tr>
				</table>
				<v-row no-gutters class="mt-4" justify="center" v-if="edit_flg">
					<v-btn color="secondary" @click="redirectToComponentEdit"> 編集する </v-btn>
				</v-row>
			</div>
		</CommonFlame>
	</div>
</template>

<script>
import axios from "axios"
import authenticate from "../../helper/authenticate"
import errorHandling from "../../helper/errorHandling"

import CommonFlame from "../shared/CommonFlame.vue"
import FunctionTitle from "../shared/FunctionTitle.vue"

export default {
	components: {
		CommonFlame,
		FunctionTitle,
	},
	data() {
		return {
			mainTitle: "部品",
			title: "部品詳細",
			component: {},
			id: this.$route.params.id,
			edit_flg: false,
		}
	},
	mounted() {
		authenticate.authenticateUser()
		this.fetchComponent()
	},
	methods: {
		fetchComponent() {
			const headers = authenticate.setHeader()
			axios
				.get(`/erp/v1/components/${this.id}`, { headers })
				.then((res) => {
					this.component = res.data.component
					this.edit_flg = res.data.edit_flg
				})
				.catch((err) => {
					errorHandling.errorResponse(err)
				})
		},
		redirectToComponentEdit() {
			this.$router.push({ name: "component_edit", params: { id: this.id } })
		},
	},
	computed: {
		isBelongsToProduct() {
			if (this.component.wildcard == false) {
				return "属する"
			} else {
				return "属しない"
			}
		},
	},
}
</script>

<style lang="scss" scoped>
@import "../../stylesheet/user/user_index.scss";

.component-show {
	.card-list {
		width: 100%;
		padding: 0 27px;
		@media all and (max-width: 767px) {
			padding: 15px;
		}
	}

	table {
		width: 100%;
		border-collapse: collapse;
		border-spacing: 0;
		font-size: 14px;
	}
	table th {
		width: 22%;
		box-sizing: border-box;
		padding: 15px;
		vertical-align: middle;
		font-weight: bold;
		text-align: center;
	}
	table td {
		box-sizing: border-box;
		padding: 15px;
		vertical-align: top;
		text-align: left;
	}
	@media all and (max-width: 767px) {
		table th,
		table td {
			display: block;
			width: 100%;
			border-bottom: none;
		}
	}
}
</style>
